import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMappedState } from 'redux-react-hook';
import { GUEST_ROUTES } from 'routes/routes';
import { FullScreenSpinner } from 'ui-kit/FullScreenSpinner';

interface AuthStateWrapperProps {
  requireAuth?: boolean;
  children: ReactNode;
  showSpinner?: boolean;
}

const AuthStateWrapper: React.FC<AuthStateWrapperProps> = ({
  requireAuth = false,
  children,
  showSpinner = true
}) => {
  const navigate = useNavigate();

  const { currentUser, isUserLoading, isInitialized } = useMappedState(state => ({
    currentUser: state.users.usersMap.get(state.users.currentUserId),
    isUserLoading: state.users.loading,
    isInitialized: state.users.initialized
  }));

  if (requireAuth && isInitialized && !currentUser) {
    navigate(GUEST_ROUTES.ROOT(), { replace: true });
    return null;
  }

  if (showSpinner && (isUserLoading || !isInitialized)) {
    return <FullScreenSpinner />;
  }

  return <>{children}</>;
};

export default AuthStateWrapper; 